'use strict';exports.__esModule = true;exports.constructStaticMapLink = undefined;var _reactDom = require('react-dom');var _reactDom2 = _interopRequireDefault(_reactDom);
var _simplifyJs = require('simplify-js');var _simplifyJs2 = _interopRequireDefault(_simplifyJs);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _booleanPointInPolygon = require('@turf/boolean-point-in-polygon');var _booleanPointInPolygon2 = _interopRequireDefault(_booleanPointInPolygon);
var _constants = require('../../constants');




var _createCustomMapPin = require('../../utils/createCustomMapPin');var _createCustomMapPin2 = _interopRequireDefault(_createCustomMapPin);



var _helpers = require('./helpers');






var _constants2 = require('./constants');



















var _cities_polygonsMin = require('./cities_polygons.min.json');var _cities_polygonsMin2 = _interopRequireDefault(_cities_polygonsMin);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}

var mapboxgl = {};
if (__CLIENT__) {
  mapboxgl = require('mapbox-gl');
}var

MapboxService =





































function MapboxService() {var _this = this;_classCallCheck(this, MapboxService);this.getMapStyles = function (locale) {var baseLink = _constants.mapboxConfig.styleBaseLink;switch (locale) {case 'he':return baseLink + '/' + MapboxService.mapStyles.he;case 'en':return baseLink + '/' + MapboxService.mapStyles.en;case 'ru':return baseLink + '/' + MapboxService.mapStyles.ru;case 'fr':return baseLink + '/' + MapboxService.mapStyles.fr;default:return baseLink + '/' + MapboxService.mapStyles.en;}};this.













  getMapOptions = function (type, isRtl) {
    switch (type) {
      case 'search':
        return Object.assign({},
        MapboxService.mapDefaultOptions, {
          maxBounds: [[33.641930, 28.450633], [36.128344, 33.581626]],
          controlPosition: isRtl ? 'bottom-left' : 'bottom-right',
          dragRotate: false,
          touchPitch: false,
          pitchWithRotate: false,
          zoom: 10 });

      case 'property':
        return Object.assign({},
        MapboxService.mapDefaultOptions, {
          scrollZoom: false,
          touchPitch: false,
          zoom: 15 });

      case 'company':
        return Object.assign({},
        MapboxService.mapDefaultOptions, {
          scrollZoom: false,
          touchPitch: false,
          dragRotate: false,
          pitchWithRotate: false,
          minZoom: 7 });

      case 'publish':
        return Object.assign({},
        MapboxService.mapDefaultOptions, {
          scrollZoom: false,
          touchPitch: false,
          pitchWithRotate: false,
          doubleClickZoom: false });

      case 'foreignPublish':
        return Object.assign({},
        MapboxService.mapForeignOptions, {
          scrollZoom: false,
          touchPitch: false,
          pitchWithRotate: false,
          doubleClickZoom: false });

      default:
        return Object.assign({},
        MapboxService.mapDefaultOptions);}


  };this.

  createMapInstance = function (mapContainer, options, locale) {var additionalIcons = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
    var map = new _this.Map(Object.assign({
      container: mapContainer,
      attributionControl: false,
      style: _this.getMapStyles(locale) },
    options));


    var nav = new _this.NavigationControl({ showCompass: false });
    map.addControl(nav, options.controlPosition || 'top-left');

    if (additionalIcons && additionalIcons.length) {
      additionalIcons.forEach(function (icon) {return _this.initIconToMap(map, icon);});
    }

    return map;
  };this.

  initIconToMap = function (map, iconType) {
    var icon = (0, _helpers.getPinIcon)(iconType);
    var image = document.createElement('img');
    image.src = icon;
    image.onload = function () {return map.addImage(iconType, image, { pixelRatio: 2 });};
  };this.

  createPin = function (lat, lng) {var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var el = document.createElement('div');
    var pin = options.draggable ? _createCustomMapPin.svgDraggablePin :

    (0, _createCustomMapPin2.default)(data.number || 0, data.type, data.animated || false, data.reviewed, undefined, true);
    el.className = 'marker marker-default ' + (options.draggable ? 'marker-draggable' : '');
    el.innerHTML = pin;

    var marker = new _this.Marker(Object.assign({
      element: el,
      anchor: 'bottom' },
    options));


    marker.setLngLat([lng, lat]);

    for (var key in data) {
      if (Object.prototype.hasOwnProperty.call(data, key)) {
        marker[key] = data[key];
      }
    }

    return marker;
  };this.

  createGeoJsonPin = function (lat, lng) {var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var typePostfix = data.reviewed ? '-reviewed' : '';
    var number = data.number > 1 ? data.number : '';
    var numberPostfix = number && (number > 10 ? '-10' : '-' + number);

    var properties = {
      icon: '' + (data.type || _constants2.PIN_TYPES.PROPERTY) + typePostfix + numberPostfix,
      ids: data.ids,
      type: data.type,
      zIndex: data.zIndex || 1 };


    return (0, _helpers.makeGeoJsonFeature)(lng, lat, properties);
  };this.

  createGeoJsonPinsData = function () {var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var features = data.map(function (item) {return _this.createGeoJsonPin.apply(_this, item);});
    return {
      type: 'FeatureCollection',
      features: features };

  };this.

  createGeoJsonPins = function () {var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var featuresData = _this.createGeoJsonPinsData(data);
    return {
      type: 'geojson',
      generateId: true,
      data: Object.assign({},
      featuresData) };


  };this.

  applyPinsGeoJson = function (map, geoJson) {
    map.addSource(_constants2.PINS_SOURCE_ID, geoJson);
    map.addLayer(_constants2.pinsLayoutConfig);
  };this.

  setContentToInfoWindow = function (content, infoWindow) {
    var container = document.createElement('div');
    _reactDom2.default.render(content, container);
    infoWindow.setDOMContent(container);
    infoWindow.getElement().style.transform = 'none';
  };this.

  createInfoWindow = function (content) {
    var container = document.createElement('div');
    _reactDom2.default.render(content, container);
    return new _this.InfoWindow({
      closeButton: true,
      closeOnMove: true,
      className: _constants2.INFO_WINDOW_CONTAINER_CLASSNAME,
      anchor: 'bottom',
      maxWidth: 'none' }).
    setDOMContent(container);
  };this.

  locateInfoWindow = function (map, pinCoordinates, infoWindow) {var _map$getContainer =
    map.getContainer(),mapWidth = _map$getContainer.offsetWidth,mapHeight = _map$getContainer.offsetHeight;
    var container = infoWindow.getElement();
    var containerMetrics = container.getBoundingClientRect();
    var pinPosition = { lat: pinCoordinates[1], lng: pinCoordinates[0] };

    var pinOffsets = (0, _helpers.getDistanceBetweenPointAndMapBorders)(map, pinPosition, mapHeight, mapWidth);
    var infoWindowOffsets = (0, _helpers.calculateInfoWindowPosition)(pinOffsets, containerMetrics.height, containerMetrics.width);

    var position = map.project(pinPosition);

    container.style.top = position.y + infoWindowOffsets.offsetY + 'px';
    container.style.left = position.x - infoWindowOffsets.offsetX + 'px';
    container.style.transform = 'none';

    var arrow = container.querySelector('.mapboxgl-popup-tip');

    arrow.style.position = 'absolute';
    arrow.style.bottom = '-10px';
    arrow.style.left = (0, _helpers.calculateArrowPosition)(
    mapWidth,
    containerMetrics.width,
    pinOffsets.left,
    infoWindowOffsets.offsetX);


    if (infoWindowOffsets.isArrowAtTop) {
      arrow.style.transform = 'rotate(180deg) translateY(' + containerMetrics.height + 'px)';
    }
  };this.

  setReviewedIcon = function (marker) {
    var number = !marker.isProject && marker.ids && marker.ids.length || 0;
    marker.reviewed = true;

    var element = marker.getElement();
    _this.zIndex += 1;
    element.style.zIndex = _this.zIndex;

    var pin = (0, _createCustomMapPin2.default)(number, marker.type, marker.animated, true, undefined, true);

    element.innerHTML = pin;
  };this.

  toggleFavoriteIconAtPin = function (marker, isFavorite) {
    var type = isFavorite ? 'favorite' : 'property';
    var pin = (0, _createCustomMapPin2.default)(0, type, marker.animated, marker.reviewed, undefined, true);
    var element = marker.getElement();

    element.innerHTML = pin;
  };this.

  createBounds = function (sw, ne) {return new _this.LngLatBounds(sw, ne);};this.

  changeMapZoom = function (map, center) {var zoom = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _constants.mapDefaultOptions.zoom;
    map.flyTo({ center: center, zoom: zoom });
  };this.

  changeMapBoundsByViewport = function (map, _ref) {var topright = _ref.topright,bottomleft = _ref.bottomleft;var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var east = topright.lon;
    var north = topright.lat;
    var south = bottomleft.lat;
    var west = bottomleft.lon;

    var bounds = [west, south, east, north];
    return _this.changeMapBounds(map, bounds, options);
  };this.

  changeMapBounds = function (map, bounds) {var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};return map.fitBounds(bounds, options);};this.

  cleanup = function () {
    (0, _createCustomMapPin.clearMemoizedPins)();
  };this.

  changeMapLocale = function (map, locale, callback) {
    var handleLoad = function handleLoad() {
      if (!map.isStyleLoaded()) {
        setTimeout(handleLoad, 200);
      } else {
        map.off('style.load', handleLoad);
        callback && callback();
      }
    };
    map.setStyle(_this.getMapStyles(locale));
    callback && map.on('style.load', handleLoad);
  };this.

  addSourceToMap = function (map, sourceId, data) {
    map.addSource(sourceId, {
      type: 'geojson',
      generateId: true,
      data: data });

  };this.

  addPolygon = function (map, polygon) {
    var data = (0, _get2.default)(polygon, 'type') ? polygon : (0, _helpers.makeGeoJsonPolygon)(polygon);
    _this.addSourceToMap(map, _constants2.CITY_POLYGON_SOURCE_ID, data);

    var beforeId = !!map.getLayer(_constants2.PINS_LAYOUT_ID) ? _constants2.PINS_LAYOUT_ID : undefined;
    map.addLayer(_constants2.cityPolygonLayoutConfig, beforeId);
    map.addLayer(_constants2.cityBorderLayoutConfig, beforeId);
  };this.

  addStreetsLayer = function (map) {
    _this.addSourceToMap(map, _constants2.STREET_SOURCE_ID, { type: 'FeatureCollection', features: [] });
    map.addLayer(_constants2.streetLayoutConfig);
  };this.

  addStaticCitiesLayer = function (map, zoom, isMobile) {
    var data = zoom > _constants2.MAX_CITY_ZOOM ? _constants2.POLYGONS_URL : _cities_polygonsMin2.default;

    _this.addSourceToMap(map, _constants2.STATIC_CITIES_SOURCE_ID, data);
    map.addLayer(_constants2.staticCitiesConfig);
    map.addLayer(isMobile ? _constants2.staticCitiesBordersConfigMobile : _constants2.staticCitiesBordersConfig);
  };this.

  changeStaticCitiesData = function (map, zoom) {
    var data = zoom > _constants2.MAX_CITY_ZOOM ? _constants2.POLYGONS_URL : _cities_polygonsMin2.default;
    var currentSource = map.getSource(_constants2.STATIC_CITIES_SOURCE_ID);

    if (currentSource) {
      currentSource.setData(data);
    }
  };this.

  removePolygon = function (map) {
    if (!map) {return;}
    var layer = map.getLayer(_constants2.CITY_POLYGON_LAYOUT_ID);
    if (layer) {
      map.removeLayer(_constants2.CITY_POLYGON_LAYOUT_ID);
      map.removeLayer(_constants2.CITY_BORDER_LAYOUT_ID);
      map.removeSource(_constants2.CITY_POLYGON_SOURCE_ID);
    }
  };this.

  convertMultiPolygonToArray = function (polygon) {var result = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var isArray = polygon[0].constructor === Array;
    if (!isArray) {
      result.push(polygon);
    } else {
      polygon.forEach(function (subpoly) {return _this.convertMultiPolygonToArray(subpoly, result);});
    }
    return result;
  };this.

  fitBoundsToPolygon = function (map, multiPolygon) {
    var bounds = _this.createBounds();
    var coordinates = _this.convertMultiPolygonToArray(multiPolygon);

    coordinates.forEach(function (point) {return bounds.extend(point);});
    _this.changeMapBounds(map, bounds, { padding: 50 });
  };this.

  calcViewportByPolygon = function (map, polygon) {
    var bounds = _this.createBounds();
    var coordinates = _this.convertMultiPolygonToArray(polygon.coordinates);

    coordinates.forEach(function (point) {return bounds.extend(point);});
    var ne = bounds.getNorthEast();
    var sw = bounds.getSouthWest();

    return {
      topright: { lat: ne.lat, lon: ne.lng },
      bottomleft: { lat: sw.lat, lon: sw.lng } };

  };this.

  polygonContainsLocation = function (point, poly) {return (0, _booleanPointInPolygon2.default)(point, (0, _helpers.makeGeoJsonPolygon)(poly));};this.

  simplifyPolygon = function (polygonCoordArr) {
    var multiplier = 1000000;
    var shifted = polygonCoordArr.map(function (_ref2) {var lat = _ref2.lat,lng = _ref2.lng;return { x: lng * multiplier, y: lat * multiplier };});
    var simplified = (0, _simplifyJs2.default)(shifted, _constants.mapboxConfig.polygonSimplificationTolerance);
    return simplified.map(function (_ref3) {var x = _ref3.x,y = _ref3.y;return [x / multiplier, y / multiplier];});
  };this.

  convertPointsToCoordinates = function (pointCoordinates, map) {
    var mapBounds = map.getBounds();
    var nePointInPixel = map.project(mapBounds.getNorthEast());
    var swPointInPixel = map.project(mapBounds.getSouthWest());
    var mapWidth = map.getContainer().clientWidth;
    var mapHeight = map.getContainer().clientHeight;

    // Trust Andrew that it works :)
    var polygonPath = pointCoordinates.map(function (item) {
      var ratioX = item[0] / mapWidth;
      var ratioY = item[1] / mapHeight;
      var pointLngOnMapInPixel = (nePointInPixel.x - swPointInPixel.x) * ratioX + swPointInPixel.x;
      var pointLatOnMapInPixel = (swPointInPixel.y - nePointInPixel.y) * ratioY + nePointInPixel.y;
      var pointInPixel = new _this.Point(pointLngOnMapInPixel, pointLatOnMapInPixel);
      return map.unproject(pointInPixel);
    });

    return polygonPath;
  };mapboxgl.accessToken = _constants.mapboxEnvs.apiKey;mapboxgl.setRTLTextPlugin && mapboxgl.getRTLTextPluginStatus() !== 'loaded' && mapboxgl.setRTLTextPlugin(_constants.mapboxConfig.rtlPluginUrl, null, true); // Lazy load the plugin
  this.Map = mapboxgl.Map;this.NavigationControl = mapboxgl.NavigationControl;this.Marker = mapboxgl.Marker;this.LngLatBounds = mapboxgl.LngLatBounds;this.InfoWindow = mapboxgl.Popup;this.Point = mapboxgl.Point;this.zIndex = 1;};MapboxService.mapDefaultOptions = { zoom: 11, cityZoom: 11, minZoom: 8, maxZoom: 21, center: { lat: 31.9430284, lng: 34.7967823 } };MapboxService.mapForeignOptions = { zoom: 3, cityZoom: 3, minZoom: 3, maxZoom: 21, center: { lat: 48.34, lng: 7.45 } };MapboxService.mapStyles = Object.assign({}, _constants.mapboxEnvs.styles);

var constructStaticMapLink = exports.constructStaticMapLink = function constructStaticMapLink(pins, _ref4) {var _ref4$width = _ref4.width,width = _ref4$width === undefined ? 860 : _ref4$width,_ref4$height = _ref4.height,height = _ref4$height === undefined ? 500 : _ref4$height;var zoom = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 15;var locale = arguments[3];
  var style = MapboxService.mapStyles[locale] || MapboxService.mapStyles.en;
  var url = _constants.mapboxConfig.staticMapBaseUrl + '/' + style + '/static';

  var markers = pins.length ?
  pins.map(function (pin) {return 'url-' + encodeURIComponent(_constants.mapboxConfig.staticMapPin2x) + '(' + pin + ')';}).join(',') :
  undefined;

  var params = pins.length > 1 ? 'auto' : pins[0] + ',' + zoom + ',0';

  return url + '/' + markers + '/' + params + '/' + width + 'x' + height + '@2x?access_token=' + _constants.mapboxEnvs.apiKey;
};exports.default =

new MapboxService();


//////////////////
// WEBPACK FOOTER
// ./src/services/MapboxService/MapboxService.js
// module id = 142
// module chunks = 0